/* eslint no-underscore-dangle: 0 */
import React from 'react';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import 'react-table/react-table.css';
import DataTable from '../DataTable/index';
import Checkbox from '../../forms/Checkbox';
import BulkActionsToolbar from '../BulkActionsToolbar/index';
import theme from '../../../../theme';
import withCheckbox from './withCheckbox';


const CheckboxTable = withCheckbox(DataTable);

export const DataTableCheckboxWrapper = styled.div`
  text-align: left;
  padding: 0 25px 0 25px;
  margin: 0;
  position: absolute;
  left: 0;
  width: auto;
  bottom: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  ${(props) => props.isChecked && css`
    background: ${theme.colors.lighter};
  `}
  
  & > div {
    display: flex;
  }
  
  @media (min-width: ${theme.breakpoints.desktopLarge}) {
    padding: 0 25px 0 50px;
  }
`;


class CheckboxDataTable extends React.Component {
  selectWidth = 65;

  constructor(props) {
    super(props);
    this.state = {
      data: this.prepareData(this.props.data), // eslint-disable-line
      selection: [],
      selectionData: [],
      selectAll: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.data !== prevProps.data) {
      this.prepareData(this.props.data);
    }
    if (this.state.selection !== prevState.selection) {
      const uniqueSelectionData = new Set([
        ...this.state.selectionData.filter((data) => this.state.selection.includes(data._id)),
        ...this.getSelectionData(),
      ]);
      this.setState({ selectionData: [...uniqueSelectionData] }); // eslint-disable-line
    }
  }

  getSelectionData = () => this.state.data
      .filter(rowData => this.selectionContainsKey(rowData._id)) // eslint-disable-line

  hasSelection = () => this.state.selection.length > 0;

  selectionContainsKey = (key) => this.state.selection.includes(key);

  prepareData = (data) => {
    if (data.length > 0) {
      const d = data.map((item) => {
        const _id = uuid() // eslint-disable-line
        return {
          _id, // eslint-disable-line
          ...item,
        };
      });
      this.setState({ data: d });
      return d;
    }
    this.setState({ data: [] });
    return [];
  };

  toggleSelection = (key, shift, row) => {// eslint-disable-line
    let selection = [...this.state.selection]; // eslint-disable-line
    const keyIndex = selection.indexOf(key);
    if (keyIndex >= 0) {
      // already selected -> remove
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1),
      ];
    } else {
      // add to selection
      selection.push(key);
    }
    this.setState({ selection });
  };

  uncheckAll = () => this.setState({ selectAll: false, selection: [] });

  // select all rows
  toggleAll = () => {
    const selectAll = !this.state.selectAll; // eslint-disable-line
    const selection = [];
    if (selectAll) {
      const Records = this.state.data;
      // we just push all the IDs onto the selection array
      Records.forEach((item) => {
        selection.push(item._id);// eslint-disable-line
      });
    }
    this.setState({ selectAll, selection });
  };

  SelectInputComponent = ({ row }) => ( // eslint-disable-line
    <DataTableCheckboxWrapper isChecked={this.selectionContainsKey(row._id)}>
      <Checkbox
        onChange={() => this.toggleSelection(row._id)}
        checked={this.selectionContainsKey(row._id)}
      />
    </DataTableCheckboxWrapper>
  );

  SelectAllInputComponent = () => (
    <Checkbox
      checked={this.state.selectAll}
      onChange={() => this.toggleAll()}
    />
  );

  render() {
    const {
      columns, className, ...otherProps // eslint-disable-line
    } = this.props;
    const { data } = this.state;

    const {
      selectWidth, SelectAllInputComponent, SelectInputComponent,
      toggleSelection, toggleAll, selectionContainsKey,
    } = this;
    const { selectAll } = this.state;
    const checkboxProps = {
      selectWidth,
      className: 'rt-bulk-checkbox',
      SelectInputComponent,
      SelectAllInputComponent,
      selectAll,
      isSelected: selectionContainsKey,
      toggleSelection,
      toggleAll,
      selectType: 'checkbox',
      getTrGroupProps: (s, r) => {
        const isSelected = r ? this.selectionContainsKey(r.original._id) : false;
        return {
          style: {
            backgroundColor: isSelected ? '#f4f3f0' : 'inherit',
            position: 'relative',
          },
        };
      },
    };

    return (
      <>
        <CheckboxTable
          {...otherProps}
          ref={r => (this.checkboxTable = r)}// eslint-disable-line
          data={data}
          columns={columns}
          className={`checkbox-table ${this.hasSelection() ? 'has-selection' : ''} ${className || ''}`}
          {...checkboxProps}
        />
        <BulkActionsToolbar
          bulkActions={this.props.bulkActions({ selectedData: this.state.selectionData })}
          toggleAll={() => this.uncheckAll()}
          selections={this.state.selection}
        />
      </>
    );
  }
}


CheckboxDataTable.propTypes = {
  data: PropTypes.any, // eslint-disable-line
  columns: PropTypes.any, // eslint-disable-line
  render: PropTypes.any, // eslint-disable-line
  bulkActions: PropTypes.any.isRequired, // eslint-disable-line
};
CheckboxDataTable.defaultProps = {
  data: [],
};


export default CheckboxDataTable;
